import { z } from 'zod';
import { gameStateSchema, gameStatePartialSchema } from '../game-state/GameState.ts';
import { PlayerColor } from '../game-state/PlayerState.ts';
import { endGameStateSchema } from '../game-state/endgame-state/EndGameState.ts';
import { uniquePlayerColorsArraySchema } from '../game-state/SharedZodSchemas.ts';
import { validateState } from '../game-state/ValidateState.ts';
const gameEventInputSchema = z.object({
    // TODO: negative deltaS values exist in production data — investigate why
    // deltaS: z.number().nonnegative(), use this after finding the bug and uncomment the unit test
    deltaS: z.number()
}).strict();
const gameEventSchema = z.object({
    input: gameEventInputSchema,
    stateChange: gameStatePartialSchema
}).strict();
const gameEventHistorySchema = z.object({
    version: z.literal(0),
    startTime: z.date(),
    initialState: gameStateSchema,
    eventsPerspectives: uniquePlayerColorsArraySchema,
    events: z.array(gameEventSchema),
    botUserNames: z.partialRecord(z.enum(PlayerColor), z.string()),
    endGameState: endGameStateSchema.optional()
}).strict();
export function validateGameEventHistory(data) {
    return validateState(gameEventHistorySchema, data);
}
